/**
 * @generated SignedSource<<e151147ead27037100aa33537a85ecf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RoleMutationGroup",
    "kind": "LinkedField",
    "name": "role",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "description",
                "variableName": "description"
              },
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name"
              },
              {
                "kind": "Literal",
                "name": "permissionIds",
                "value": ([]/*: any*/)
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "RoleModifyRolePayload",
        "kind": "LinkedField",
        "name": "create",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewRoleModalMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewRoleModalMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "49c1ab5bfdfe2e8b765abe09b25966ae",
    "id": null,
    "metadata": {},
    "name": "NewRoleModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewRoleModalMutation(\n  $name: String!\n  $description: String!\n) {\n  role {\n    create(input: {name: $name, description: $description, permissionIds: []}) {\n      role {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "868961abba56d8ff07e82d595e6fae9d";

export default node;
